import polyfillClosest from 'element-closest';
polyfillClosest(window);
